import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';

import Rollbar from 'rollbar';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ROLLBAR_SERVICE } from '../app.module';

// This simple service makes a remote call that returns the IP address of the client.
@Injectable({
  providedIn: 'root'
})
export class IpService {
  private http = inject(HttpClient);
  private functions = inject(AngularFireFunctions);
  private rollbar = inject<Rollbar>(ROLLBAR_SERVICE);


  // Returns an observable that provides the IP address as a string.
  public getIPAddressFromCloudFunctions() {
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    return this.functions.httpsCallable<void, string>('getIpAddress')().pipe(
      catchError(error => {
        this.rollbar.error('Error fetching IP from Cloud Functions', error);
        return of('');
      })
    );
  }

  // Returns an observable that provides the IP address as a string.
  public getIPAddressFromIpify() {
    return this.http.get('https://api.ipify.org/', { responseType: 'text' }).pipe(
      catchError(error => {
        this.rollbar.error('Error fetching IP from ipify.org', error);
        return of('');
      })
    );
  }
}
